import { BasicShowtime } from '@/types/showtimes';
import { buildLateNightLabel } from '@/utils/date-time-helper';
import { filterDisplayableShowtimes, splitShowtimesByDayBoundary } from '@/utils/showtime-filters';
import clsx from 'clsx';
import { ShowtimeComponent } from '../showtime';
import showtimeListStyles from './showtime-list.module.scss';

type ShowtimeListComponentProps = {
  cinemarkMovieId: number;
  className?: string;
  dataLinkCategory: string;
  forceChipStyle?: boolean;
  listClassName?: string;
  showtimes: BasicShowtime[];
  theaterId: number;
  timeZone?: string;
};

export const ShowtimeListComponent = ({
  cinemarkMovieId,
  className,
  dataLinkCategory,
  forceChipStyle = false,
  listClassName,
  showtimes,
  theaterId,
  timeZone,
}: ShowtimeListComponentProps): React.JSX.Element => {
  const upcomingShowtimes = filterDisplayableShowtimes(showtimes);
  const { lateNightShowtimes, sameDayShowtimes } = splitShowtimesByDayBoundary(upcomingShowtimes, timeZone);
  const hasLateNightShowtimes = lateNightShowtimes.length > 0;

  if (!hasLateNightShowtimes) {
    return (
      <div className={clsx(showtimeListStyles['showtime-list'], className, listClassName)}>
        {upcomingShowtimes.map(showtime =>
          <ShowtimeComponent key={showtime.id}
            cinemarkMovieId={cinemarkMovieId}
            dataLinkCategory={dataLinkCategory}
            forceChipStyle={forceChipStyle}
            showtime={showtime}
            theaterId={theaterId}
            timeZone={timeZone}
          />
        )}
      </div>
    );
  }

  const lateNightLabel = buildLateNightLabel(
    sameDayShowtimes[0]?.startTime,
    lateNightShowtimes[0].startTime,
    timeZone
  );

  return (
    <div className={clsx('flex flex-col gap-sm', className)}>
      {!!sameDayShowtimes.length &&
        <div className={clsx(showtimeListStyles['showtime-list'], listClassName)}>
          {sameDayShowtimes.map(showtime =>
            <ShowtimeComponent key={showtime.id}
              cinemarkMovieId={cinemarkMovieId}
              dataLinkCategory={dataLinkCategory}
              forceChipStyle={forceChipStyle}
              showtime={showtime}
              theaterId={theaterId}
              timeZone={timeZone}
            />
          )}
        </div>
      }
      <div className="bg-muted flex flex-col gap-sm rounded-lg px-ms py-sm">
        <p className="text-sm font-semibold"
          data-test="showtime-list-late-night-label"
        >
          {lateNightLabel}
        </p>
        <div className={clsx(showtimeListStyles['showtime-list'], listClassName)}>
          {lateNightShowtimes.map(showtime =>
            <ShowtimeComponent key={showtime.id}
              cinemarkMovieId={cinemarkMovieId}
              dataLinkCategory={dataLinkCategory}
              forceChipStyle={forceChipStyle}
              showtime={showtime}
              theaterId={theaterId}
              timeZone={timeZone}
            />
          )}
        </div>
      </div>
    </div>
  );
};
